module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"paymentMethod":"Payment method","change":"Change","addNewCard":"Add card","failed":"Last payment was unsuccessful {failedAt}"}}')
  delete Component.options._Ctor
}
